import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import { useDispatch, useSelector } from "react-redux";

import Button from "../../components/Atoms/Button";
import Txt from "../../components/Atoms/Txt";
import CloseIcon from "../../assets/close.png";
import CruzeiroIconApp from "../../assets/cruzeiroIconApp.png";
import { setHideDownloadApp } from "../../redux/userData";

const DownloadApp = (props) => {
  const { config } = props;
  const [isVisible, setIsVisible] = useState(false);

  const { hideDownloadApp } = useSelector((state) => state.userData);

  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(setHideDownloadApp(true));
    setIsVisible(false);
  };

  const handleOpenApp = () => {
    const userAgent = navigator.userAgent || window.opera;

    if (/android/i.test(userAgent)) {
      window.open(
        "https://play.google.com/store/apps/details?id=br.com.cruzeiro.nacaoazul&hl=pt_BR",
        "_blank"
      );
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      window.open(
        "https://apps.apple.com/br/app/cruzeiro-na%C3%A7%C3%A3o-azul/id1632719034",
        "_blank"
      );
    }

    dispatch(setHideDownloadApp(true));
    setIsVisible(false);
  };

  useEffect(() => {
    if (!hideDownloadApp) {
      setIsVisible(true);
    }
  }, [hideDownloadApp]);

  return (
    isVisible && (
      <StyledContainer config={config}>
        <section className="left-section">
          <Button className="close-button" onClick={handleClose}>
            <img src={CloseIcon} alt="close icon" className="close-icon" />
          </Button>
        </section>
        <section className="mid-section">
          <img src={CruzeiroIconApp} alt="logo icon" className="logo-icon" />
          <div className="mid-section-message">
            <Txt
              typo="paragraph-lg"
              color={config.colors.BRAND.DARK}
              className="mid-message"
            >
              Baixe o aplicativo do Cruzeiro
            </Txt>
          </div>
        </section>
        <section className="right-section">
          <Button className="interact-button" onClick={handleOpenApp}>
            <Txt
              typo="tag-button-lg"
              color={config.colors.BRAND.BASE}
              className="interact-button-text"
            >
              Ver
            </Txt>
          </Button>
        </section>
      </StyledContainer>
    )
  );
};

export default DownloadApp;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  padding: 16px 0px;
  background-color: ${(props) => props.config.colors.WHITE.W};

  .left-section {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;

    img {
      height: 16px;
      width: 16px;
    }
  }

  .mid-section {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    flex: 5;

    img {
      flex: 1;
      height: 34px;
      width: 34px;
      object-fit: contain;
    }

    .mid-section-message {
      flex: 4;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .right-section {
    display: flex;
    flex: 1;

    .interact-button {
      background-color: transparent;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 !important;
    }

    .interact-button-text {
      white-space: nowrap;
      line-height: 100% !important;
      text-align: center;
      vertical-align: middle;
      text-transform: uppercase;
    }
  }
`;
